import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=3e11c30c&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e11c30c')) {
      api.createRecord('3e11c30c', component.options)
    } else {
      api.reload('3e11c30c', component.options)
    }
    module.hot.accept("./Greeting.vue?vue&type=template&id=3e11c30c&", function () {
      api.rerender('3e11c30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/accounts/Greeting.vue"
export default component.exports